import React from 'react';
import './HomeSection3.css';


const HomeSection3 = ({
    lightBg, topLine, lightText, lightTextDesc, headLine, description, buttonLabel, img, alt, imgStart, grantImage

}) => {

    return(
        <div className={lightBg ? 'home__home-section' : 'home__home-section darkBg'}>
            <div className="container">
                <div
                className="row home__home-row"
                style={{display: 'flex', flexDirection: imgStart ? 'row-reverse' : 'row'}}>
                    <div className="col">
                        <div className="home__home-text-wraper">
                            <div className="top-line">{topLine}</div>
                            <h1 className={lightText ? 'heading' : 'heading dark'}>{headLine}</h1>
                            <p className={lightTextDesc ? 'home__home-subtitle' : 'home__home-subtitle dark'}>{description}</p>
                            {headLine === 'Shenzu Spending' && description === 'AI-powered B2B SaaS with blockchain smart contracts.' ? (
                                <div className="powered-branding">
                                    <span className="powered-label">Powered by</span>
                                    <div className="powered-branding-row">
                                        <a className="grant-image-link" href="https://elevenlabs.io/startup-grants" target="_blank" rel="noopener noreferrer">
                                            <img className="grant-image" src="https://eleven-public-cdn.elevenlabs.io/payloadcms/pwsc4vchsqt-ElevenLabsGrants.webp" alt="ElevenLabs" width="250" />
                                        </a>
                                        <img className="sarvam-logo" src="/images/sarvam-logo.png" alt="Sarvam" />
                                    </div>
                                </div>
                            ) : null}

                        </div>
                    </div>
                    <div className="col">
                        <div className="home__home-img-wrapper">
                            <img className="home__home-img" src={img} alt={alt}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeSection3;
